"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var noDOM = typeof document === 'undefined';
var _default = exports.default = noDOM;